import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Modal from '../General/Modal';
import './ManualOrderAdjustmentsCsvModal.scss';

const EMPTY_SUMMARY = { totalCount: 0, validCount: 0, invalidCount: 0 };

const ManualOrderAdjustmentsCsvModal = props => {
  const { error, fileName, isCommitting, isLoading, onClose, onCommit, preview } = props;
  const summary = preview?.summary || EMPTY_SUMMARY;
  const rows = preview?.rows || [];
  const canCommit = !!preview && summary.totalCount > 0 && summary.invalidCount === 0 && !isCommitting;
  const counts = [
    { label: 'Orders', value: summary.totalCount },
    { label: 'Valid', value: summary.validCount, className: 'valid' },
    { label: 'Invalid', value: summary.invalidCount, className: 'invalid' }
  ];

  return (
    <Modal close={isCommitting ? () => {} : onClose} container_class='manual-order-adjustments-csv-modal-outer'>
      <div className='manual-order-adjustments-csv-modal-header'>
        <div className='manual-order-adjustments-csv-modal-title'>Preview CSV Orders</div>
        <div className='manual-order-adjustments-csv-modal-file'>{fileName}</div>
      </div>

      <div className='manual-order-adjustments-csv-modal-content'>
        {isLoading && <div className='manual-order-adjustments-csv-modal-loading'>Validating every order…</div>}
        {error && <div className='manual-order-adjustments-csv-modal-error'>{error}</div>}

        {preview && (
          <>
            <div className='manual-order-adjustments-csv-modal-counts'>
              {counts.map(count => (
                <div key={count.label} className={cn('manual-order-adjustments-csv-modal-count', count.className)}>
                  <div className='value'>{count.value}</div>
                  <div className='label'>{count.label}</div>
                </div>
              ))}
            </div>

            <div className='manual-order-adjustments-csv-modal-table-wrap'>
              <table className='manual-order-adjustments-csv-modal-table'>
                <thead>
                  <tr>
                    <th>Row</th>
                    <th>Brand</th>
                    <th>Creator</th>
                    <th>Order ID</th>
                    <th>Order Amount</th>
                    <th>Commission Rate (%)</th>
                    <th>Commission</th>
                    <th>Currency</th>
                    <th>Transaction Date</th>
                    <th>Custom Code</th>
                    <th>Validation</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map(row => (
                    <tr key={row.rowNumber} className={cn({ invalid: !row.isValid })}>
                      <td>{row.rowNumber}</td>
                      <td>{row.brandName ? `${row.brandName} (${row.Brand_id})` : row.Brand_id}</td>
                      <td>{row.creatorName ? `${row.creatorName} (${row.User_id})` : row.username || row.User_id}</td>
                      <td>{row.order_id}</td>
                      <td>{row.order_amount}</td>
                      <td>{row.commission_rate}%</td>
                      <td>{row.commission_amount ?? '—'}</td>
                      <td>{row.currency}</td>
                      <td>{row.transaction_date}</td>
                      <td>{row.code || '—'}</td>
                      <td className='validation'>{row.isValid ? 'Valid' : row.errors.join(' ')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>

      <div className='manual-order-adjustments-csv-modal-actions'>
        <button className='manual-order-adjustments-csv-modal-btn secondary' disabled={isCommitting} onClick={onClose}>
          Cancel
        </button>
        <button className='manual-order-adjustments-csv-modal-btn primary' disabled={!canCommit} onClick={onCommit}>
          {isCommitting ? 'Creating orders…' : `Commit ${summary.totalCount} order${summary.totalCount === 1 ? '' : 's'}`}
        </button>
      </div>
    </Modal>
  );
};

ManualOrderAdjustmentsCsvModal.propTypes = {
  error: PropTypes.string,
  fileName: PropTypes.string.isRequired,
  isCommitting: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCommit: PropTypes.func.isRequired,
  preview: PropTypes.object
};

export default ManualOrderAdjustmentsCsvModal;
